<template>
  <div>
    <Topnav />
    <div class="content">
      <div class="jumbotron text-center">
        <h2>Public Bots</h2>
        <hr class="bg-dark"/>
        <p>These are the bots created by other users.</p>
      </div>

      <div class="row mb-5">
          <div v-for="(bot,index) in bots" :key="index" class="col col-xs-12 col-md-6 col-lg-4">
            <div class="card m-1">
                <div class="card-body">
                    <h4 class="card-title">{{bot.first_name}}</h4>
                    <p class="card-text">@{{bot.username}}</p>
                    <a :href="'https://t.me/'+bot.username" class="btn btn-primary" target="blank">Chat</a>
                </div>
            </div>
          </div>

      </div>

    </div>
  </div>
</template>

<script>
import Topnav from "@/components/Topnav.vue";

import ApiService from '@/services/ApiService'
import TelegramService from '@/services/TelegramService'


export default {
  name: "AllBots",
  components: {
    Topnav,
  },
  data: function(){
      return {
          bots: []
      }
  },
  methods:{
      getBots: function(){
          ApiService.getBots()
          .then(function(res){
              res.forEach(function(element){
                  TelegramService.getMe(element.token)
                  .then(function(bot){
                      this.bots.push(bot)
                  }.bind(this))
                  .catch(function(){
                      console.log("#")
                  })
              }.bind(this));
          }.bind(this))
          .catch(err=>{
              console.log(err)
          })
      }
  },
  mounted(){
      this.getBots()
  }
};
</script>

<style>
</style>